import cComponents from "../../secrets-web/src/components/common";

import BusyOverlay from "./BusyOverlay";
import UserAvatar from "./UserAvatar";
import AuthLogo from "./AuthLogo";

const commonComponents = {
  ...cComponents,
  BusyOverlay,
  UserAvatar,
  AuthLogo
}

export default commonComponents;